import {NavItem} from '@interfaces/nav-item';


// Remote technician: he only answers calls (spec of 03/11/2026), so no dashboard, technicians or devices
export const navItemsOperatorBo: NavItem[] = [
  {
    displayName: 'menu.rooms',
    iconName: 'material-symbols:support-agent',
    route: '/support/room/list',
  },
  {
    displayName: 'menu.conversations',
    iconName: 'solar:chat-round-line-linear',
    route: '/conversations',
  },
  {
    displayName: 'menu.documents',
    iconName: 'solar:inbox-archive-broken',
    route: '/filemanager',
  },
];
